module.exports = __webpack_public_path__ + "static/media/sega.118df070.png";